import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

const path = "/promotorias"

class PromotoriaService {
  getPromotorias() {
    return axios.get(API + path)
  }
  getPromotoriasLogado() {
    return axios.get(API + path + "/usuario-logado");
  }
  pesquisarPromotorias(filters) {
    const { nome, municipioId } = filters;

    return axios.get(API + path + "/pesquisar", {
      params: {
        nome: nome !== "" ? nome : undefined,
        municipioId: municipioId !== "" ? municipioId : undefined
      }
    });
  }
}
const instancePromotoria = new PromotoriaService();
export default instancePromotoria;